import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { IoSearchSharp, IoAddOutline } from 'react-icons/io5';
import { useQuery } from 'react-query';
import { color, CredusButton } from 'ui';

import CandidateDataTable from './tables/CandidateDataTable';
import ComponentLoader from '../../ComponentLoader';
import { CandidateContext, CandidateData as ICandidates } from '../../../../contexts/CandidateContext';
import testApi from '../../../../api/test';

interface CandidateDataProps {
  setShowImportCandidate: React.Dispatch<React.SetStateAction<boolean>>;
}

const CandidateData = ({ setShowImportCandidate }: CandidateDataProps) => {
  const { candidateCategory } = useContext(CandidateContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [candidates, setCandidates] = useState<ICandidates[]>([]);
  const { periodId, categoryId } = candidateCategory;
  const { data, isLoading } = useQuery(['candidates'], () =>
    testApi.getCandidateByCategory(1, periodId, categoryId)
  );

  const handleClick = () => {
    setShowImportCandidate(true);
  };

   const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchTerm(e.target.value);
      if(e.target.value.trim() === "" || e.target.value === undefined) return;
  
      const filteredData = data?.data.filter((candidate) => {
        return (
          candidate.firstName
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          candidate.surname
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          candidate.surname
            .toLowerCase()
            .includes(e.target.value.toLowerCase()) ||
          candidate.candidateNumber
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        );
      });

      if (filteredData?.length === 0 || !filteredData) {
        return setCandidates([]);
      }
      setCandidates(filteredData);
    };

    useEffect(() => {
      if(data?.data) {
        setCandidates(data?.data)
      }
    }, [data?.data])


  return (
    <div>
      {isLoading ? (
        <ComponentLoader loaderText="getting candidates" />
      ) : (
        <>
          {' '}
          <TopDiv>
            <SearchDiv>
              <Input
                placeholder="Try searching for information here"
                value={searchTerm}
                onChange={handleSearch}
              />
              <IoSearchSharp color="#C3CAD9" />
            </SearchDiv>
            <FilterDiv>
              <CredusButton outlined disabled>
                Batch Invite
              </CredusButton>
              <CredusButton
                preffix={<IoAddOutline size={'25px'} />}
                onClick={handleClick}
              >
                Add New
              </CredusButton>
            </FilterDiv>
          </TopDiv>
          <CandidateDataTable candidates={candidates} />
        </>
      )}
    </div>
  );
};

export default CandidateData;

const TopDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 2rem;
`;
const SearchDiv = styled.div`
  width: 326px;
  height: 36px;
  background: ${color.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  box-shadow: 0px 1.44px 3.6px rgba(38, 51, 77, 0.03);
`;

const Input = styled.input`
  outline: none;
  border: none;
  width: 90%;
  &::placeholder {
    color: #adb8cc;
  }
`;

const FilterDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;
